// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host{display:inline-block}.log-icon{display:flex;padding:var(--uap-log-integration-icon-padding, 10px);background-color:var(--uap-log-background-color-white);border:1px solid var(--uap-log-border-color-grey);box-shadow:0 2px 5px 0 var(--uap-log-box-shadow-color);border-radius:50%}.tooltip-nowrap{white-space:nowrap}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
